import * as config from 'config';
import type { Channel } from 'pusher-js';
import Pusher from 'pusher-js';
import { getStoredAuthData } from 'utils/auth';
import create from 'zustand';

type Store = {
  channel: Channel | null;
  createOrUpdate: (userId: string) => void;
  destroy: () => void;
  renew: () => void;
};

const getChannelName = (id: string) => `private-${id}`;

const createPusherInstance = () => {
  return new Pusher(config.pusher.key, {
    authEndpoint: `${config.accountableAPI.baseUrl}/v1/users/me/pusher/auth`,
    cluster: 'eu',
    auth: {
      params: {},
      headers: {
        Authorization: `Bearer ${getStoredAuthData('access_token')}`,
      },
    },
  });
};

const pusherChannelStore = create<Store>((set, get) => ({
  channel: null,
  createOrUpdate: (userId: string) => {
    const channelName = getChannelName(userId);

    const channel = get().channel;

    if (channel && channel.name === channelName) return;

    get().destroy();

    const instance = createPusherInstance();

    set({ channel: instance.subscribe(channelName) });
  },
  destroy: () => {
    const channel = get().channel;
    if (!channel) return;

    channel.unbind_all();
    channel.unsubscribe();
    channel.disconnect();

    set({ channel: null });
  },
  renew: () => {
    const currentChannel = get().channel;
    if (!currentChannel) return;

    const channelName = currentChannel.name;

    get().destroy();

    const instance = createPusherInstance();

    set({ channel: instance.subscribe(channelName) });
  },
}));

const pusherChannelController = {
  useChannel: () => pusherChannelStore((state) => state.channel),
  createOrUpdate: (userId: string) =>
    pusherChannelStore.getState().createOrUpdate(userId),
  destroy: () => pusherChannelStore.getState().destroy(),
  renew: () => pusherChannelStore.getState().renew(),
};

export default pusherChannelController;
